// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Cursors } from '@shared/commons/Cursors';
import { TerceraChartBaseRenderer } from '../TerceraChartBaseRenderer';
import { MouseButtons } from '@front/controls/UtilsClasses/ControlsUtils';
import { TerceraChartToolRenderer } from './TerceraChartToolRenderer';
import { LayersEnum } from '../../Utils/LayersEnum';
export class TerceraChartEraserRenderer extends TerceraChartBaseRenderer {
    constructor(chart) {
        super(chart);
        this.Active = false;
        this.eraserCursor = Cursors.eraserCursor;
        this.SetClassName('TerceraChartEraserRenderer');
    }
    ProcessMouseDown(e) {
        if (!this.Active)
            return super.ProcessMouseDown(e);
        const wCont = this.chart.windowsContainer;
        const len_win = wCont.Windows.length;
        for (let i_win = 0; i_win < len_win; i_win++) {
            const window = wCont.Windows[i_win];
            const toolsRenderer = window.GetRenderer(TerceraChartToolRenderer);
            if ((toolsRenderer === null || toolsRenderer === void 0 ? void 0 : toolsRenderer.HoverToolGet()) != null) {
                toolsRenderer.RemoveTool(toolsRenderer.HoverToolGet());
                return true;
            }
        }
        if (e.Button == MouseButtons.Right)
            return true;
        return super.ProcessMouseDown(e);
    }
    ProcessMouseMove(e) {
        if (this.Active) {
            e.NeedRedraw = LayersEnum.CrossHair;
        }
        return super.ProcessMouseMove(e);
    }
    GetCursor(e) {
        if (this.Active) {
            const len = this.chart.windowsContainer.Windows.length;
            for (let i = 0; i < len; i++) {
                if (this.chart.windowsContainer.Windows[i].ClientRectangle.Contains(e.Location.X, e.Location.Y)) {
                    return this.eraserCursor;
                }
            }
        }
        return null;
    }
    ThemeChanged() {
        super.ThemeChanged();
        this.eraserCursor = Cursors.eraserCursor;
    }
    Dispose() {
        this.chart = null;
        super.Dispose();
    }
}
